import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { useTradingRefresh } from "./tradingRefresh";

// A strategy name that opens the strategy (Trading page); plain text when the
// strategy is gone or there's nowhere to open it.
const StrategyLink = ({ strategyId, name, instrument }) => {
  const { openStrategy } = useTradingRefresh();
  if (!strategyId || !name || !openStrategy) return name || "Deleted strategy";
  return (
    <Button
      type="link"
      size="small"
      style={{
        padding: 0,
        height: "auto",
        whiteSpace: "normal",
        textAlign: "start",
      }}
      onClick={() => openStrategy(strategyId, instrument)}
    >
      {name}
    </Button>
  );
};

StrategyLink.propTypes = {
  strategyId: PropTypes.string,
  name: PropTypes.string,
  instrument: PropTypes.oneOf(["stocks", "options"]).isRequired,
};

export default StrategyLink;
